import { CSSProperties } from "@material-ui/core/styles/withStyles";

const listItemText: CSSProperties = {
  // fontSize: 16,
};

export const styles = {
  listItemText,
};
